import React, { useEffect, useRef, useState } from "react";
import PageLayout from "../../../components/PageLayout";
import CustomCard from "../../../components/Common/CustomCard";
import withRouter from "../../../components/Common/withRouter";
import ApplicationDescription from "./ApplicationDescription";
import form_messages from "../../../constants/form_messages";
import { useFormik } from "formik";
import * as Yup from "yup"
import { createApplication, deleteApplication, editApplication, regenerateAppkey, resetApplicationResponseMsg } from "../../../store/menu/application/actions";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import CustomPopup from "../../../components/Common/CustomPopup";
import { CustomToast } from "../../../components/Lystface/Common/CustomToast";
import { getListOfApps, updateActiveManageApp } from "../../../store/menu/home/actions";
import { imageValidation } from "../../../config";
import isEqual from 'lodash/isEqual';
import delIcon from '../../../assets/images/lystfacelogos/BillingDetails/delete-card-icon.svg'
import form_input_patterns from "../../../constants/form_input_patterns";
import { copyToClipBoardNewIcon } from "../../../components/Common/SvgIcons";







const Application = (props) => {
    //state and constants
    const pageName = "Add application"
    const dispatch = useDispatch();
    const [activeAppName, setActiveAppName] = useState("")
    const keysRef = useRef();
    const [app, setApp] = useState(null)
    const [popupDetails, setPopupDetails] = useState({ open: false, titleText: '', bodyText: '', primaryButtonText: '', secondaryButtonText: '', primaryButtonPath: '', secondaryButtonPath: '' })
    const ApplicationState = state => state.Application
    const AppListState = state => state.Home
    const [applicationStatus, setApplicationStatus] = useState(props.applicationStatus)
    const [appId, setAppId] = useState(null)
    const { maxFileSize, allowedFormats } = imageValidation
    const [delPopupDetails, setDelPopupDetails] = useState({ open: false })
    const [appIcon, setAppIcon] = useState(null)
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [croppedImage, setCroppedImage] = useState(null)
    const [isremoved, setIsremoved] = useState(false)
    const [validationMessage, setValidationMessage] = useState(null);
    const appIdRef = useRef();
    const appKeyRef = useRef();







    const ApplicationProperties = createSelector(ApplicationState, Application => ({
        applicationLoading: Application?.loading,
        applicationResponseMessage: Application?.responseMessage,
        applicationResponseStatus: Application?.responseStatus,
        applicationKey: Application?.appKey,
        applicationId: Application?.appId,
        regeneratedAppKey: Application?.regeneratedAppKey,
        generateApikeyLoading: Application?.generateApikeyLoading,
        applicationName: Application?.appName,
        applicationDelLoading: Application?.applicationDelLoading,
        applicationIcon: Application?.applicationIcon



    }))
    const AppListProperties = createSelector(
        AppListState,
        AppListDetails => ({
            appsList: AppListDetails?.appsListDetails?.appsList,
            activeManageApp: AppListDetails?.activeManageApp,
            responseMessage: AppListDetails?.appsListDetails?.responseMessage,
            responseStatus: AppListDetails?.appsListDetails?.responseStatus,
            loading: AppListDetails?.appsListDetails?.loading,


        })
    )
    const { appsList, activeManageApp } = useSelector(
        AppListProperties
    )
    const { applicationResponseMessage, applicationResponseStatus, applicationLoading, applicationKey, applicationId, regeneratedAppKey, generateApikeyLoading, applicationName, applicationDelLoading, applicationIcon } = useSelector(ApplicationProperties)


    //effects


    useEffect(() => {
        if (props.router.location.pathname.split('/')[2] !== 'add-application' && appsList.length === 0) {
            props.router.navigate('/application')

        }

    }, [props.router.location.pathname.split('/')[2], appsList])

    useEffect(() => {
        if (props.router.location.pathname.split('/')[2] !== "add-application") {
            setAppId(props.router.location.pathname.split('/')[2])
        }
    }, [props.router.location.pathname.split('/')[2]])

    useEffect(() => {
        if (applicationStatus !== "manage") {

            const handleBeforeUnload = (e) => {
                const confirmationMessage = 'Are you sure you want to leave?';
                e.returnValue = confirmationMessage;
                return confirmationMessage;


            };
            window.addEventListener('beforeunload', handleBeforeUnload);


            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);

            };
        }

    }, [applicationStatus]);



    //getting listof apps to show the app selected
    useEffect(() => {
        if (applicationStatus === "manage")
            dispatch(getListOfApps({}))
    }, [applicationStatus])

    const handleCopyAppDetails = (e) => {
        let ref = null
        const name = e.currentTarget.getAttribute('data-name');
        if (name === 'applicationKey') {
            ref = appKeyRef.current.innerText;
        } else {
            ref = appIdRef.current.innerText;
        }

        const textarea = document.createElement('textarea');
        textarea.value = ref;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        let copyElement = null
        if (name === 'applicationKey') {
            copyElement = document.getElementById(name);
        } else {
            copyElement = document.getElementById(name);
        }
        copyElement.textContent = "Copied.";
        setTimeout(() => {
            copyElement.textContent = "";
        }, 2000);
    }

    //triggering toast message when response message is not empty,dispatching action to reset the state to trigger the toast again
    useEffect(() => {
        if (applicationResponseMessage !== null) {
            CustomToast({
                message: applicationResponseMessage,
                status: applicationResponseStatus === 'Error' ? 'failure' : 'success',
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            dispatch(resetApplicationResponseMsg())
            if (applicationResponseStatus === 'Success') {
                setApplicationStatus('manage');
            }
            if (applicationResponseStatus === 'Success' && applicationStatus === "delete") {
                props.router.navigate('/application')
            }
            if (
                applicationResponseStatus === 'Success' && applicationStatus === "create" &&
                applicationKey && regeneratedAppKey === "") {

                setPopupDetails({
                    open: true, title: 'AppKey_AppId', 'inputRef': keysRef, titleText: applicationName ? applicationName : 'Create Application',
                    bodyText: <div className="billing"><p>App key and app ID have been generated successfully for {applicationName}! </p><p>For further steps, please refer to the API documentation. The key can be copied once</p>
                        <div className="app-details-container">
                            <div className="form-input-container">
                                <span className="key-label">App ID</span>
                                <div className="copy-key-container">
                                    <span className="app-key" ref={appIdRef}>{applicationId}</span>
                                    <div onClick={(e) => handleCopyAppDetails(e)} data-name="applicationId" className="copy-icon">
                                        <span className="copied-text" id="applicationId"></span>

                                        {copyToClipBoardNewIcon}

                                    </div>
                                </div>

                            </div>
                            <div className="form-input-container">
                                <span className="key-label">API key</span>
                                <div className="copy-key-container">

                                    <span className="app-key" ref={appKeyRef}>{applicationKey}</span>
                                    <div onClick={(e) => handleCopyAppDetails(e)} data-name="applicationKey" className="copy-icon">
                                        <span className="copied-text" id="applicationKey"></span>

                                        {copyToClipBoardNewIcon}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>,
                    // subText: `APP ID : ${applicationId},APP KEY : ${applicationKey}`,
                    primaryButtonText: 'Close', secondaryButtonPath: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application", primaryButtonPath: "/application", handleClickPrimaryButton: handleClose, handleClose: handleClose,
                    className: "add-app"
                })
            }

        }

    }, [applicationResponseMessage, applicationKey, applicationResponseStatus])

    //setting the app selected when applist and appId from route param is changing
    useEffect(() => {
        if (appsList.length !== 0) {
            let appID = appId ? appId : applicationId
            let activeApp = appsList.find(obj => obj.app_id === appID)
            dispatch(updateActiveManageApp(activeApp))
            setApp(activeApp)
            setActiveAppName(activeApp?.app_name)
        }
    }, [appId, appsList, applicationId])

    useEffect(() => {
        if (applicationStatus !== "create") {
            setAppIcon((applicationIcon && app?.app_id === applicationId) ? applicationIcon : app?.app_icon)
        }
    }, [applicationIcon, app, applicationStatus])

    useEffect(() => {
        setActiveAppName(activeManageApp?.app_name)
    }, [activeManageApp])


    //actions

    //action for closing custom popup
    const handleClose = () => {
        setPopupDetails({
            open: false, titleText: 'Discard changes', bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Discard', secondaryButtonText: 'Cancel', primaryButtonPath: '/application', secondaryButtonPath: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application", primaryButtonPath: "/application", handleClose: handleClose
        })

    }

    //action for clicking on save on card 
    const handleOnSave = () => {
        validationType.handleSubmit();


    }

    const handleEditApp = () => {
        setApplicationStatus("edit")
        validationType.resetForm()
    }

    //action for triggering action based on clicking regenerate key in edit application
    const handleGenerateKey = () => {
        dispatch(regenerateAppkey({ 'app_id': app?.app_id }, props.router.navigate))
    }

    //action for copy app details from custom popup when clicking on regenerate app key
    const handleCopyKeys = () => {
        let ref = keysRef.current.innerText
        const textarea = document.createElement('textarea');
        textarea.value = ref;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }


    //handling Navigation when clicking on Primary Button for custom popup
    const handleNavigation = (from) => {
        if (from === 'applicationModification') {
            props.router.navigate('/application')

        }
        else if (from === 'regenerateKey') {
            handleGenerateKey()

        }
        else if (from === 'AppKey_AppId') {
            props.router.navigate('/application')

        }
    }

    //action for basic behaviour after clicking primary button on custom popup
    const handleClickPrimaryButton = (from) => {
        setPopupDetails({
            open: false, titleText: 'Discard changes', bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Discard', secondaryButtonText: 'Cancel', primaryButtonPath: '/application', secondaryButtonPath: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application", primaryButtonPath: "/application", handleClose: handleClose
        })
        handleNavigation(from)

    }

    //closing the popup when secondary button is clicked on custom popup
    const handleClickSecondaryButton = () => {
        setPopupDetails({
            open: false, titleText: 'Discard changes', bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Discard', secondaryButtonText: 'Cancel', primaryButtonPath: '/application', secondaryButtonPath: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application", primaryButtonPath: "/application", handleClose: handleClose
        })
    }

    //action for clicking cancel on card
    const handleOnCancel = () => {
        const fieldvalues = Object.values(validationType.values)
        const isValuesChanged = isEqual(validationType.values, initialValuesForForm)
        const allEmpty = fieldvalues.filter(obj => obj.length === 0).length === fieldvalues.length
        if (allEmpty || isValuesChanged) {
            handleNavigation('applicationModification')
        }
        else {
            setPopupDetails({
                open: true, title: 'applicationModification', titleText: 'Discard Changes', bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Discard', primaryButtonPath: '/application', secondaryButtonPath: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application", primaryButtonPath: "/application", handleClickPrimaryButton: handleClickPrimaryButton, handleClickSecondaryButton: handleClickSecondaryButton, handleClose: handleClose
            })
        }

    }

    const handleCloseModal = () => {
        setPopupDetails({ open: false })
    }

    const handleRemoveApp = () => {
        setPopupDetails({ open: false })
        setApplicationStatus("delete")
        dispatch(deleteApplication({ app_id: app?.app_id }))
    }

    //action for deleting app
    const handleDeleteApp = () => {
        setPopupDetails({
            open: true, titleText: 'Delete application', bodyText: `Deleting application will also delete the API key linked to it. This might affect your services.`, primaryButtonText: 'Delete anyway', secondaryButtonText: 'Cancel', handleClickPrimaryButton: handleRemoveApp, handleClickSecondaryButton: handleCloseModal
        })
    }
    //custom button details for customcard

    const buttonDetails = [
        { 'buttonText': 'Cancel', buttonType: 'secondary', path: null, 'callBackFunction': handleOnCancel },
        { 'buttonText': 'Save', buttonType: 'primary', path: null, 'callBackFunction': handleOnSave },




    ]

    const managebuttonDetails = [
        { 'buttonText': 'Delete', buttonType: 'icon', buttonIcon: delIcon, path: null, 'callBackFunction': handleDeleteApp },
        { 'buttonText': 'Edit', buttonType: 'primary', path: null, 'callBackFunction': handleEditApp },


    ]

    //converting s3 url from response to base64 url

    const convertS3toBase64 = async (url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64Data = reader.result.split(',')[1];
                validationType.setFieldValue("appIconFile", `data:image/jpeg;base64,${base64Data}`)
            };

            reader.readAsDataURL(blob);
        } catch (error) {
            console.error('Error fetching data from S3:', error);
        }
    };

    //validation for fields in add/edit application
    const initialValuesForForm = {
        appName: `${applicationStatus !== "create" ? app?.app_name?.trim() : ""}`,
        appDescription: `${applicationStatus !== "create" ? (app?.app_desc) ? app?.app_desc?.trim() : "" : ""}`,
        appIcon: `${applicationStatus !== "create" ? "" : ""}`
    }
    const validationType = useFormik({
        enableReinitialize: true,

        initialValues: initialValuesForForm,
        validationSchema: Yup.object().shape({
            appName: Yup.string().trim()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("App name")
                )
                .required(form_messages.Application.appname.Required)
                .min(3, form_messages.Application.appname.MIN3MAX35)
                .max(35, form_messages.Application.appname.MIN3MAX35)
            ,
            // .matches(/^\S*$/, form_messages.Application.appname.NOSPACES),
            appDescription: Yup.string().trim()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("App description")
                )
                .min(3, form_messages.Application.appDescription.MIN3MAX100)
                .max(100, form_messages.Application.appDescription.MIN3MAX100),
        }),
        onSubmit: values => {
            const form = new FormData();
            values.appName.length > 0 && form.append('app_name', values.appName.trim())
            values.appDescription.length > 0 && form.append('app_desc', values.appDescription.trim())
            if (appIcon || values.appIconFile) {
                form.append('app_icon', values.appIconFile ? values.appIconFile : appIcon);
            }
            if (applicationStatus !== "create") {
                form.append('app_id', app.app_id)
                dispatch(editApplication({ formData: form, application_icon: croppedImage, appId: app?.app_id }))
            }
            else {
                dispatch(createApplication({ formData: form, application_icon: croppedImage }))

            }
        },
    })

    //action for opening popup basede on generate key
    const handleClickGenerateKey = () => {
        setPopupDetails({
            open: true, title: 'regenerateKey', titleText: 'Generate new app key', bodyText: 'Creating new key will delete the old key, This might affect your app. Are you sure you want to do?', primaryButtonText: 'Generate anyway', primaryButtonPath: '/application', secondaryButtonPath: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application", primaryButtonPath: "/application", handleClose: handleClose, handleClickPrimaryButton: handleClickPrimaryButton, handleClickSecondaryButton: handleClickSecondaryButton
        })


    }

    //handling profile upload in add/edit application

    const handlePhotoUplaod = (e, from) => {
        let file;
        if (from === "drag") {
            file = e.dataTransfer.files[0];

        }
        else {
            file = e.currentTarget.files[0];

        }
        const validImageTypes = allowedFormats; // Add more types as needed
        const maxSize = maxFileSize * 1024 * 1024; // 1MB in bytes
        const formatsList = validImageTypes.map((format) => format.split('/')[1]?.toUpperCase()).join(",")
        if (file) {
            if (validImageTypes.includes(file.type)) {
                if (file.size > maxSize) {
                    setValidationMessage("Unsupported image size. Please upload a valid image file.")

                }
                else {
                    const reader = new FileReader();

                    reader.onloadend = () => {
                        validationType.setFieldValue("cropIcon", reader.result)
                        validationType.setFieldValue("appIconFile", file)
                        validationType.setFieldTouched("cropIcon", true, false);
                        validationType.validateForm();

                        const changeEvent = {
                            target: {
                                name: "cropIcon",
                                value: reader.result
                            }
                        };

                        validationType.handleChange(changeEvent);

                        validationType.validateForm();

                    }
                    reader.readAsDataURL(file);
                    setValidationMessage(null)

                }
                setIsremoved(!isremoved)

            } else {
                setValidationMessage("Unsupported image format. Please upload a valid image file.")

            }

        }

    }
    const handleDeleteIcon = () => {
        setAppIcon(null)
        validationType.setFieldValue("appIcon", "")
        validationType.setFieldValue("cropIcon", "")
        if (app?.app_icon) {
            validationType.setFieldValue("appIconFile", "")

        }
        else {
            validationType.setFieldValue("appIconFile", undefined)
        }
        setFileInputKey(Date.now());
    }


    const breadcrumbItems = [
        { text: "Home", link: "/" },
        { text: "Application", link: "/application" },
        { text: applicationStatus !== "create" ? activeAppName : pageName, link: applicationStatus !== "create" ? `/application/${app?.app_id}` : "/application/add-application" },
    ];

    //using Common card for both add and edit application and changing the data based on edit/add
    return (
        <React.Fragment>
            <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems} >
                <CustomCard titleText={applicationStatus === "manage" || applicationStatus === "delete" ? "Manage application" : applicationStatus === "edit" ? "Edit application" : "Add application"}
                    buttonsList={applicationStatus === "manage" || applicationStatus === "delete" ? managebuttonDetails : buttonDetails}
                    applicationLoading={applicationLoading}
                    applicationDelLoading={applicationDelLoading}
                >
                    <ApplicationDescription validationType={validationType} handlePhotoUplaod={handlePhotoUplaod} applicationStatus={applicationStatus} app={app} handleClickGenerateKey={handleClickGenerateKey} regeneratedAppKey={regeneratedAppKey} generateApikeyLoading={generateApikeyLoading} handleDeleteIcon={handleDeleteIcon} appIcon={appIcon} fileInputKey={fileInputKey} setFileInputKey={setFileInputKey} isremoved={isremoved} setCroppedImage={setCroppedImage} croppedImage={croppedImage} validationMessage={validationMessage} setValidationMessage={setValidationMessage} />
                </CustomCard>
                {popupDetails.open &&
                    <CustomPopup
                        popupDetails={popupDetails}
                    />
                }
            </PageLayout>
        </React.Fragment>
    );
};

export default withRouter(Application);
